import { render, staticRenderFns } from "./left-side-bar.vue?vue&type=template&id=a5401bb4"
import script from "./left-side-bar.vue?vue&type=script&lang=js"
export * from "./left-side-bar.vue?vue&type=script&lang=js"
import style0 from "./left-side-bar.vue?vue&type=style&index=0&id=a5401bb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports